import React from "react";
import Typewriter from "typewriter-effect";

function Typing() {
    return (
        <Typewriter
            options={{
                strings: [
                    "Software Developer",
                    "Full Stack Developer",
                    "Flutter App Developer",
                    "Frontend Developer",
                    "Backend Developer",
                    "MERN Developer",
                    "AI ENTHUSIAST"
                ],
                autoStart: true,
                loop: true,
                deleteSpeed: 50,
            }}
        />
    );
}

export default Typing;
